import type { Generator } from './types';
import { generateMul2x1 } from './mul2x1';
import { generateMul2x2 } from './mul2x2';
import { generateDivRemainder } from './div-remainder';
import { generateTwoStep } from './two-step';
import { generateAddCarry } from './add-carry';
import { generateSubBorrow } from './sub-borrow';
import { generateMul3x1 } from './mul3x1';
import { generateDiv2x1 } from './div2x1';
import { generateDiv3x1 } from './div3x1';
import { generateFracCompare } from './frac-compare';
import { generateDecAdd } from './dec-add';
import { generateNumberThousand } from './number-thousand';
import { generateDecimalBasic } from './decimal-basic';
import { generateAreaRectangle } from './area-rectangle';
import { generateTimeClockReading } from './time-clock-3xia';
import { generateTimeDuration } from './time-duration';
// ── 三上 backport generators (grade 3.1) ──────────────────────────
import { generateCount10000 } from '../math-gen3-up/count-10000';
import { generatePlaceValue } from '../math-gen3-up/place-value';
import { generateMul2x1Up } from '../math-gen3-up/mul-2x1-up';
import { generateDivNoRem } from '../math-gen3-up/div-no-rem';
import { generateAddSubVerticalUp } from '../math-gen3-up/add-sub-vertical-up';
import { generateTimeClock } from '../math-gen3-up/time-clock';

export { generateMul2x1 } from './mul2x1';
export { generateMul2x2 } from './mul2x2';
export { generateDivRemainder } from './div-remainder';
export { generateTwoStep } from './two-step';
export { generateAddCarry } from './add-carry';
export { generateSubBorrow } from './sub-borrow';
export { generateMul3x1 } from './mul3x1';
export { generateDiv2x1 } from './div2x1';
export { generateDiv3x1 } from './div3x1';
export { generateFracCompare } from './frac-compare';
export { generateDecAdd } from './dec-add';
export { generateNumberThousand } from './number-thousand';
export { generateDecimalBasic } from './decimal-basic';
export { generateAreaRectangle } from './area-rectangle';
export { generateTimeClockReading } from './time-clock-3xia';
export { generateTimeDuration } from './time-duration';
// ── 三上 backport re-exports ──────────────────────────────────────
export { generateCount10000 } from '../math-gen3-up/count-10000';
export { generatePlaceValue } from '../math-gen3-up/place-value';
export { generateMul2x1Up } from '../math-gen3-up/mul-2x1-up';
export { generateDivNoRem } from '../math-gen3-up/div-no-rem';
export { generateAddSubVerticalUp } from '../math-gen3-up/add-sub-vertical-up';
export { generateTimeClock } from '../math-gen3-up/time-clock';

export const MATH_GENERATORS: Record<string, Generator> = {
  'math.mul.2x1': generateMul2x1,
  'math.mul.2x2': generateMul2x2,
  'math.div.remainder': generateDivRemainder,
  'math.word.two-step': generateTwoStep,
  'math.calc.addsub-vertical': generateAddCarry,
  'math.calc.addsub-vertical-sub': generateSubBorrow,
  'math.mul.3x1': generateMul3x1,
  'math.div.no-remainder': generateDiv2x1,
  'math.div.mul-relation': generateDiv3x1,
  'math.fraction.compare': generateFracCompare,
  'math.decimal.addsub': generateDecAdd,
  'math.number.thousand': generateNumberThousand,
  'math.decimal.basic': generateDecimalBasic,
  'math.area.rectangle': generateAreaRectangle,
  'math.time.clock': generateTimeClockReading,
  'math.time.duration': generateTimeDuration,
  // ── 三上 grade 3.1 ──────────────────────────────────────────────
  'math.number.10000': generateCount10000,
  'math.place.value.4digits': generatePlaceValue,
  'math.mul.2x1.review': generateMul2x1Up,
  'math.div.1digit.no-rem': generateDivNoRem,
  'math.add.carry.multi': generateAddSubVerticalUp,
  'math.sub.borrow.multi': generateAddSubVerticalUp,
  'math.time.elapsed': generateTimeClock,
};

export function getMathGenerator(kp: string): Generator | undefined {
  return MATH_GENERATORS[kp];
}
